

import React, { useRef } from 'react'

export let ContactUs = ({children}) => {
    return <a href="https://duraproducts.com.au/contact-us/" target={'_blank'}>{children??'Contact Us'}</a>
}
